import { render, staticRenderFns } from "./SignDetailDialog.vue?vue&type=template&id=585d5433&scoped=true&"
import script from "./SignDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SignDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignDetailDialog.vue?vue&type=style&index=0&id=585d5433&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d5433",
  null
  
)

export default component.exports